export const SET_FILTER_CATEGORIES = 'SET_FILTER_CATEGORIES';
export const SET_FILTER_FEATURES = 'SET_FILTER_FEATURES';
export const SET_FILTER_VOLATILITY = 'SET_FILTER_VOLATILITY';
export const DELETE_FILTER = 'DELETE_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';

export const setFilterCategoriesAction = categories => ({
    type: SET_FILTER_CATEGORIES,
    payload: categories
});

export const setFilterFeaturesAction = features => ({
    type: SET_FILTER_FEATURES,
    payload: features
});

export const setFilterVolatilityAction = volatility => ({
    type: SET_FILTER_VOLATILITY,
    payload: volatility
});

export const deleteFilterAction = filterId => ({
    type: DELETE_FILTER,
    payload: filterId
});

export const resetFiltersAction = () => ({
    type: RESET_FILTERS
});
